import { camelCase } from 'lodash';

export function collateralColorPalette(
  collateralType: string,
  colors: Record<string, string>,
  alpha?: number
) {
  const color = colors[camelCase(collateralType)] || 'rgba(255, 255, 255, 1)'; // Default to white

  if (alpha) {
    return color.replace('1)', `${alpha})`);
  }

  return color;
}
